export default function preloadImages(images, filenames) {
    filenames.forEach(filename => {
        const img = new Image();
        img.src = `/static/images/${ filename }`;
        images.push(img);
    });
}
